export enum ACTIONS {
	START_GAME = 'START_GAME',
	SET_PLAYER_MARK = 'SET_PLAYER_MARK',
	UPDATE_BOARD = 'UPDATE_BOARD',
	SET_GAME_RESULTS = 'SET_GAME_RESULTS',
	NEXT_ROUND = 'NEXT_ROUND',
	RESET_ROUND = 'RESET_ROUND',
	CANCEL = 'CANCEL',
	RESET_GAME = 'RESET_GAME',
	UPDATE_DATA_FROM_LOCAL_STORAGE = 'UPDATE_DATA_FROM_LOCAL_STORAGE',
}

export enum GameStatus {
	ROUND_TIED = 'ROUND_TIED',
	RESTART_ROUND = 'RESTART_ROUND',
	ROUND_WON = 'ROUND_WON',
	ROUND_LOST = 'ROUND_LOST',
	DEFAULT = 'DEFAULT',
}
